import React from "react";
import { Store } from "lucide-react";

/**
 * Row of pill-style filter chips. Renders a "Todas" chip + one chip per option.
 * Compact, mobile-friendly, no dropdown.
 *
 * @param {string} value       — currently selected id or "all"
 * @param {(v:string)=>void} onChange
 * @param {Array<{id:string,name:string}>} options
 * @param {string=} label      — small label shown before chips (optional)
 * @param {string=} allLabel   — copy for the "all" chip (default "Todas")
 * @param {string=} testidPrefix — data-testid prefix (default "admin-filter")
 * @param {React.ReactNode=} icon — leading icon component element (default Store)
 */
export default function FilterChips({
  value,
  onChange,
  options,
  label,
  allLabel = "Todas",
  testidPrefix = "admin-filter",
  icon,
}) {
  if (!options || options.length === 0) return null;
  const chips = [{ id: "all", name: allLabel }, ...options];
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={`${testidPrefix}-row`}>
      {(icon !== undefined ? icon : <Store className="w-4 h-4 text-[#8A796F]" />)}
      {label && (
        <span className="text-xs font-semibold uppercase tracking-wide text-[#8A796F] mr-1">
          {label}
        </span>
      )}
      {chips.map((c) => {
        const active = value === c.id;
        return (
          <button
            key={c.id}
            type="button"
            onClick={() => onChange(c.id)}
            data-testid={`${testidPrefix}-${c.id}`}
            className={`h-9 px-3.5 rounded-full text-sm font-semibold border transition-colors active:scale-95 ${
              active
                ? "bg-[#FF7878] border-[#FF7878] text-white shadow-sm"
                : "bg-white border-[#EADBCE] text-[#4A3B32] hover:bg-[#FCF9F2]"
            }`}
          >
            {c.name}
          </button>
        );
      })}
    </div>
  );
}
